import { render, staticRenderFns } from "./DspBatchAdd.vue?vue&type=template&id=a2390752&scoped=true"
import script from "./DspBatchAdd.vue?vue&type=script&lang=js"
export * from "./DspBatchAdd.vue?vue&type=script&lang=js"
import style0 from "./DspBatchAdd.vue?vue&type=style&index=0&id=a2390752&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2390752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2390752')) {
      api.createRecord('a2390752', component.options)
    } else {
      api.reload('a2390752', component.options)
    }
    module.hot.accept("./DspBatchAdd.vue?vue&type=template&id=a2390752&scoped=true", function () {
      api.rerender('a2390752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/DspBatchAdd.vue"
export default component.exports